import {EFormSteps, EStatus, ETechPartnerStatus} from './definitions';

const registrationPoints = [
  'У вас есть номер телефона, на который будет зарегистрирован канал Telegram.\n' +
    'Этот номер телефона не связан ни с каким другим аккаунтом.',
  'Пройдите регистрацию в Telegram.',
  'Убедитесь, что аккаунт не заблокирован и вы можете отправлять/принимать сообщения в обычном режиме.',
  'Проверьте "Связанные устройства" в приложении. Если там много неактивных сессий, удалите их. \n' +
    'Это освободит "слот" для подключения к Telegram.',
  'Убедитесь, что аккаунт, который вы хотите подключить, активен и доступен на вашем мобильном устройстве.',
];

export default {
  status: {
    [EStatus.DRAFT]: 'Черновик',
    [EStatus.LOGIN_REQUIRED]: 'Требует внимания',
    [EStatus.IN_PROGRESS]: 'На регистрации',
    [EStatus.LOGGED_OUT]: 'Требует внимания',
    [EStatus.CANCELLED]: 'Отключен',
    [EStatus.DONE]: 'Работает исправно',
  },
  techPartnerStatus: {
    [ETechPartnerStatus.NEW]: 'Черновик',
    [ETechPartnerStatus.ACCEPTED]: 'Черновик',
    [ETechPartnerStatus.DELETED]: 'Отключен',
  },
  registrationCheck: {
    title: 'Проверьте, что у вас есть все необходимое для регистрации канала Telegram',
    points: registrationPoints,
  },
  formSteps: {
    [EFormSteps.SETTINGS]: 'Условия регистрации и настройка',
    [EFormSteps.QR]: 'Подключение канала',
  },
  editForm: {
    settings: 'Настройки канала',
    subject: 'Отправитель',
    subjectHint:
      'Отправитель — системное имя канала, используется внутри edna Pulse и не отображается получателям',
    name: 'Внутреннее название канала',
    nameHint: 'Это название будет отображаться в списке каналов edna Pulse и в отчетности',
  },
  connectionLostBanner: {
    title: 'Соединение с каналом потеряно. Вы можете подключить канал повторно.',
    action: 'Подключить повторно',
  },
  connectionForm: {
    title: 'Подключение Telegram',
    steps: [
      'Откройте приложение Telegram на телефоне. Перейдите в Устройства <0>→</0> Войти по QR-коду. Наведите камеру на QR-код на экране.',
      'Не закрывайте страницу, пока статус канала не изменится на «Работает исправно» или система не выдаст ошибку.',
    ],
    qrTitle: 'Ваш QR-код для подключения',
    qrHint:
      'В момент перехода по ссылке QR-кода вы создадите новый канал Telegram.\nДальше соединение с edna произойдет автоматически.',
    connectionError: 'Возникла непредвиденная ошибка. Соединение не установлено.',
  },
  viewForm: {
    title: 'Данные канала',
    disconnect: 'Отключить канал',
  },
  disconnectModal: {
    title: 'Отключить канал?',
    hint: 'Отключение канала не влияет на активность лицензии. Для отключения лицензии, пожалуйста, свяжитесь с вашим менеджером.',
    submitButton: 'Отключить',
  },
  techPartner: {
    code: 'Ссылка для регистрации',
    codeHint:
      'Скопируйте и отправьте эту ссылку клиенту, чтобы он завершил регистрацию канала Telegram',
    connectionError: 'Соединение с каналом потеряно. Скопируйте ссылку ниже и отправьте её клиенту',
  },
  regenerateCodeModal: {
    title: 'Обновить ссылку для регистрации?',
    subTitle: 'После обновления текущая ссылка станет недействительной и будет создана новая',
  },
  publicForm: {
    title:
      'На этой странице вы можете зарегистрировать канал Telegram. Информацию об этой регистрации получит ваш провайдер {{partnerName}}',
    helpTitle: 'Проверьте, что у вас есть все необходимое для регистрации канала Telegram',
    helpPoints: [
      ...registrationPoints,
      'Отключите дополнительный пароль для входа в настройках приложения Telegram в разделе «Безопасность».',
    ],
    qrTitle: 'Ваш QR-код для подключения',
    qrHint:
      'Откройте приложение Telegram на телефоне <0>→</0> Устройства <0>→</0> Войти по QR-коду. Наведите камеру на QR-код на экране.',
    successTitle: 'Канал отправлен на регистрацию',
    successHint:
      'Узнать статус регистрации вы можете у своего провайдера<br/><0>{{partnerName}}</0>',
    errorTitle: 'По этой ссылке регистрация канала Telegram недоступна:<br/><0>{{error}}</0>',
    errorHint:
      'Чтобы получить новую ссылку, свяжитесь с вашим провайдером<br/><0>{{partnerName}}</0>',
    errors: {
      unknown: 'такой страницы не существует',
    },
  },
};
